<template>
  <CContainer fluid>
    <CCard>
      <CCardBody>
        <CTabs v-show="usuarioLogado.tipo == 2">
          <CTab>
            <template slot="title">
              <CIcon name="cil-bookmark" /> Resumo
            </template>
            <CCard>
              <CCardBody>
                <CInputCheckbox
                  label="PROAP"
                  required
                  autocomplete="email"
                  invalid-feedback="Email é obrigatório"
                >
                  <template #append-content>
                    <CIcon name="cil-at" />
                  </template>
                </CInputCheckbox>
                <CInputCheckbox
                  label="PONTO PSI"
                  required
                  autocomplete="email"
                  invalid-feedback="Email é obrigatório"
                >
                  <template #append-content>
                    <CIcon name="cil-at" />
                  </template>
                </CInputCheckbox>

                <CRow>
                  <CCol col="6">
                    <CSelect
                      placeholder="ANO"
                      :options="anos"
                      :value.sync="params.ano"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                  <CCol col="6">
                    <CSelect
                      placeholder="MES"
                      :options="mes"
                      :value.sync="params.mes"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol col="6">
                    <CSelect
                      placeholder="PROFISSIONAIS"
                      :options="profisisonais"
                      :value.sync="params.profissional"
                      required
                      :disabled="usuarioLogado.tipo == 2"
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                  <CCol col="6">
                    <CSelect
                      placeholder="CONVENIO"
                      :options="convenios"
                      :value.sync="params.convenio"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>

            <CCard>
              <CCardBody>
                <CRow>
                  <CDataTable
                    :items="dadosFechamento"
                    :fields="fieldsFechamento"
                    :noItemsView="not_found"
                    column-filter
                    hover
                    sorter
                    small
                    :fixed="fixed"
                    :items-per-page="5"
                    :dark="dark"
                    pagination
                  >
                  </CDataTable>
                </CRow>
              </CCardBody>
            </CCard>
            <CCard style="margin-top:4em">
              <CCardBody>
                <CRow>
                  <CCol col="6">
                    <CCard>
                      <CCardBody>
                        <CChartPie
                          :datasets="listaDadosServico"
                          :labels="dadoServicos"
                        />
                      </CCardBody>
                    </CCard>
                  </CCol>
                  <CCol col="6">
                    <CCard>
                      <CCardBody>
                        <CChartBar
                          :datasets="buscaDadosProfissional"
                          :labels="conveniosChart"
                        />
                      </CCardBody>
                    </CCard>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CTab>
          <CTab>
            <template slot="title">
              <CIcon name="cil-bookmark" /> Extras
            </template>
            <CCard>
              <CCardBody> <dashboardQueryFilters /> </CCardBody>
            </CCard>
          </CTab>
        </CTabs>
        <CTabs v-show="usuarioLogado.tipo == 1">
          <CTab>
            <template slot="title">
              <CIcon name="cil-bookmark" /> Fechamento
            </template>
            <CCard>
              <CCardBody>
                <CInputCheckbox
                  label="PROAP"
                  required
                  autocomplete="email"
                  invalid-feedback="Email é obrigatório"
                >
                  <template #append-content>
                    <CIcon name="cil-at" />
                  </template>
                </CInputCheckbox>
                <CInputCheckbox
                  label="PONTO PSI"
                  required
                  autocomplete="email"
                  invalid-feedback="Email é obrigatório"
                >
                  <template #append-content>
                    <CIcon name="cil-at" />
                  </template>
                </CInputCheckbox>

                <CRow>
                  <CCol col="6">
                    <CSelect
                      placeholder="ANO"
                      :options="anos"
                      :value.sync="params.ano"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                  <CCol col="6">
                    <CSelect
                      placeholder="MES"
                      :options="mes"
                      :value.sync="params.mes"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol col="6">
                    <CSelect
                      placeholder="PROFISSIONAIS"
                      :options="profisisonais"
                      :value.sync="params.profissional"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                  <CCol col="6">
                    <CSelect
                      placeholder="CONVENIO"
                      :options="convenios"
                      :value.sync="params.convenio"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                </CRow>
                <CRow>
                  <div class="div_cards">
                    <div>
                      <span id="rec"></span>
                      <p class="title">N° Atendimentos (tempo)</p>
                      <p class="valueP">
                        {{ dadosGerais.numAtendimentos }}
                      </p>
                    </div>
                     <div>
                      <span id="rec"></span>
                      <p class="title">N° Atendimentos</p>
                      <p class="valueP">
                        {{ dadosGerais.numAtendimentosLiterais }}
                      </p>
                    </div>
                    <div>
                      <span id="rec"></span>
                      <p class="title">Valor total</p>
                      <p class="valueP">{{ dadosGerais.valorTotal }}</p>
                    </div>
                    <div>
                      <span id="rec"></span>
                      <p class="title">Ticket Medio</p>
                      <p class="valueP">{{ dadosGerais.ticketMedio }}</p>
                    </div>
                    <div>
                      <span id="rec"></span>
                      <p class="title">Valor Repasse</p>
                      <p class="valueP">{{ dadosGerais.valorRepasse }}</p>
                    </div>
                  </div>
                </CRow>
              </CCardBody>
            </CCard>

            <CCard>
              <CCardBody>
                <CRow>
                  <CDataTable
                    :items="dadosFechamento"
                    :fields="fieldsFechamento"
                    :noItemsView="not_found"
                    column-filter
                    hover
                    sorter
                    small
                    :fixed="fixed"
                    :items-per-page="5"
                    :dark="dark"
                    pagination
                  >
                  </CDataTable>
                </CRow>
              </CCardBody>
            </CCard>
            <CCard style="margin-top:4em">
              <CCardBody>
                <CRow>
                  <CCol col="6">
                    <CCard>
                      <CCardBody>
                        <CChartPie
                          :datasets="listaDadosServico"
                          :labels="dadoServicos"
                        />
                      </CCardBody>
                    </CCard>
                  </CCol>
                  <CCol col="6">
                    <CCard>
                      <CCardBody>
                        <CChartBar
                          :datasets="buscaDadosProfissional"
                          :labels="conveniosChart"
                        />
                      </CCardBody>
                    </CCard>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CTab>
          <CTab>
            <template slot="title">
              <CIcon name="cil-bookmark" /> Resumo
            </template>
            <CCard>
              <CCardBody>
                <CRow>
                  <CCol col="6">
                    <CSelect
                      placeholder="ANO"
                      :options="anos"
                      :value.sync="params.ano"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                  <CCol col="6">
                    <CSelect
                      placeholder="MES"
                      :options="mes"
                      :value.sync="params.mes"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol col="6">
                    <CSelect
                      placeholder="PROFISSIONAIS"
                      :options="profisisonais"
                      :value.sync="params.profissional"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                  <CCol col="6">
                    <CSelect
                      placeholder="CONVENIO"
                      :options="convenios"
                      :value.sync="params.convenio"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                  <CCol col="6">
                    <CSelect
                      placeholder="SERVIÇO"
                      :options="[
                        {
                          label: 'TODOS',
                          value: null
                        },
                        {
                          label: 'CONSULTA',
                          value: '1'
                        },
                        {
                          label: 'AVALIAÇÃO',
                          value: '2'
                        }
                      ]"
                      :value.sync="params.service"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol col="12">
                    <div class="div_cards">
                      <div>
                        <span id="rec"></span>
                        <p class="title">N° Atendimentos</p>
                        <p class="valueP">{{ dadosGerais.numAtendimentos }}</p>
                      </div>
                      <div>
                        <span id="rec"></span>
                        <p class="title">Valor total</p>
                        <p class="valueP">{{ dadosGerais.valorTotal }}</p>
                      </div>
                      <div>
                        <span id="rec"></span>
                        <p class="title">Ticket Medio</p>
                        <p class="valueP">{{ dadosGerais.ticketMedio }}</p>
                      </div>
                      <div>
                        <span id="rec"></span>
                        <p class="title">Valor Repasse</p>
                        <p class="valueP">{{ dadosGerais.valorRepasse }}</p>
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
            <CCard>
              <CCardBody>
                <CRow>
                  <CCol col="12">
                    <CDataTable
                      :items="dadosReumo"
                      :fields="fieldsResumo"
                      :noItemsView="not_found"
                      column-filter
                      hover
                      sorter
                      small
                      :fixed="fixed"
                      :items-per-page="15"
                      :dark="dark"
                      pagination
                    >
                    </CDataTable>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CTab>
          <CTab>
            <template slot="title">
              <CIcon name="cil-bookmark" /> Faturamento
            </template>
            <CCard>
              <CCardBody>
                <CRow>
                  <CCol col="6">
                    <CSelect
                      placeholder="ANO"
                      :options="anos"
                      :value.sync="params.ano"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                  <CCol col="6">
                    <CSelect
                      placeholder="MES"
                      :options="mes"
                      :value.sync="params.mes"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol col="6">
                    <CSelect
                      :options="profisisonais"
                      :value.sync="params.profissional"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                  <CCol col="6">
                    <CSelect
                      placeholder="CONVENIO"
                      :options="convenios"
                      :value.sync="params.convenio"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                  <CCol col="6">
                    <CSelect
                      placeholder="PACIENTE"
                      :options="pacienteFiltro"
                      :value.sync="params.paciente"
                      required
                      invalid-feedback="* Campo obrigatório"
                      @change="buscaDados()"
                    >
                    </CSelect>
                  </CCol>
                </CRow>
                <CRow>
                  <div class="div_cards">
                    <div>
                      <span id="rec"></span>
                      <p class="title">N° Atendimentos</p>
                      <p class="valueP">{{ dadosGerais.numAtendimentos }}</p>
                    </div>
                    <div>
                      <span id="rec"></span>
                      <p class="title">Valor Total</p>
                      <p class="valueP">{{ dadosGerais.valorTotal }}</p>
                    </div>

                    <div>
                      <span id="rec"></span>
                      <p class="title">Ticket Médio</p>
                      <p class="valueP">{{ dadosGerais.ticketMedio }}</p>
                    </div>
                    <div>
                      <span id="rec"></span>
                      <p class="title">Valor Repasse</p>
                      <p class="valueP">{{ dadosGerais.valorRepasse }}</p>
                    </div>
                  </div>
                </CRow>
              </CCardBody>
            </CCard>
          </CTab>
          <CTab :disabled="false">
            <template slot="title">
              <CIcon name="cil-bookmark" /> KPI`s
            </template>
            <kpis />
          </CTab>
          <CTab>
            <template slot="title">
              <CIcon name="cil-bookmark" /> PPR
            </template>
            <controlePPM />
          </CTab>
          <CTab>
            <template slot="title">
              <CIcon name="cil-bookmark" /> Pacientes
            </template>
            <pacientes />
          </CTab>
          <CTab>
            <template slot="title">
              <CIcon name="cil-bookmark" /> Baixa
            </template>
            <br />
            <CDataTable
              :items="pacientesFiltros"
              :fields="fieldsBaixa"
              pagination
              column-filter
              clickable-rows
              @row-clicked="perfilPaciente($event)"
            >
            </CDataTable>
          </CTab>
          <CTab>
            <template slot="title">
              <CIcon name="cil-bookmark" /> Logs
            </template>
            <br />
            <CDataTable
              :items="logs"
              :fields="fieldsLogs"
              pagination
              column-filter
              responsive
              :dark="dark"
              clickableRows
              :items-per-page="10"
              sorter
              hover
            >
            </CDataTable>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>
  </CContainer>
</template>
<script>
import { CChartBar } from "@coreui/vue-chartjs";
import { CChartPie } from "@coreui/vue-chartjs";
import controlePPM from "./controlePPM/controlePPM.vue";
import dashboardQueryFilters from "./components/dashboard/PPR/dashboardQueryFilters.vue";
import kpis from "./components/dashboard/KPIS/kpis.vue";
import pacientes from "./components/dashboard/PACIENTES/pacientes.vue";
import moment from 'moment'
export default {
  name: "CChartBarExample",
  components: {
    CChartBar,
    CChartPie,
    controlePPM,
    dashboardQueryFilters,
    kpis,
    pacientes,
  },
  data() {
    return {
      baseUrl: `${process.env.VUE_APP_API_BASE_URL}resumo-financeiro`,
      label: "GitHub Commits",
      backgroundColor: "#f87979",
      idUser: "",

      usuarioLogado: {
        id: "",
        tipo: "",
      },
      data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11],
      url_destino: "",
      items: [],
      showAdmGraf: true,
      showProfGraf: true,
      cardConvenio: "CONVÊNIO",
      cardParticular: "PARTICULAR",
      totalValor: "0",
      totalParticular: "0",
      totalConvenio: "0",
      metaConvenio: false,
      metaParticular: false,
      //filtros
      conveniosChart: [],
      profisisonais: [{ label: "PROFISSIONAIS", value: null }],
      convenios: [{ label: "TODOS", value: null }],
      logs: [],
      fieldsLogs: [
      {
          key: "data",
          label: "Data",
          _style: "min-width:200px",
        },
        {
          key: "hora",
          label: "Data",
          _style: "min-width:200px",
        },
        {
          key: "log",
          label: "Log",
          _style: "min-width:600px",
        },
      ],
      fieldsFechamento: [
        {
          key: "service",
          label: "Serviço",
          _style: "min-width:200px",
          filter: false,
        },
        {
          key: "qtdeConsultas",
          label: "Total de Consultas",
          _style: "min-width:50px;",
          filter: false,
        },
        // {
        //   key: "totValor",
        //   label: "Valor total",
        //   _style: "min-width:50px;",
        //   filter: false,
        // },

        {
          key: "taxa",
          label: "Imposto 13,33%",
          _style: "min-width:50px;",
          filter: false,
        },
        {
          key: "valorRepasse",
          label: "Valor Repasse",
          _style: "min-width:50px;",
          filter: false,
        },
      ],
      mes: [
        { label: "MES", value: null },
        { label: "JANEIRO", value: "01" },
        { label: "FEVEREIRO", value: "02" },
        { label: "MARÇO", value: "03" },
        { label: "ABRIL", value: "04" },
        { label: "MAIO", value: "05" },
        { label: "JUNHO", value: "06" },
        { label: "JULHO", value: "07" },
        { label: "AGOSTO", value: "08" },
        { label: "SETEMBRO", value: "09" },
        { label: "OUTUBRO", value: "10" },
        { label: "NOVEMBRO", value: "11" },
        { label: "DEZEMBRO", value: "12" },
      ],
      anos: [],
      params: {
        profissional: null,
        convenio: null,
        ano: null,
        mes: null,
        paciente: null,
        service: null
      },
      dadosGerais: {
        valorTotal: "",
        numAtendimentos: "",
        ticketMedio: "",
        valorRepasse: "",
      },
      mesAtual: {
        id: "",
        nome: "",
      },
      fields: [
        {
          key: "name",
          label: "Profissional",
          _style: "min-width:200px",
        },
        {
          key: "total_consultas",
          label: "Total de Consultas",
          _style: "min-width:100px;",
          filter: false,
        },

        {
          key: "consultas_convenio",
          label: "Total de Consultas Convênio",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "total_particular",
          label: "Total de Consultas particulares",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "receita_convenio",
          label: "Total R$ Convênio",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "valor_particular",
          label: "Total R$ Particular",
          _style: "min-width:40px;",
          filter: false,
        },
        {
          key: "valor_geral",
          label: "Total Geral R$",
          sorter: false,
          filter: false,
        },
      ],
      dadosFechamento: [],
      fieldsResumo: [
        {
          key: "name",
          label: "Convenio",
          _style: "min-width:150x",
        },
        {
          key: "qtd_atendimentos",
          label: "Atendimentos",
          _style: "min-width:150px;",
          filter: false,
        },

        {
          key: "tot_imposto",
          label: "Imposto",
          _style: "min-width:150px;",
          filter: false,
        },
        {
          key: "valor_repasse",
          label: "Valor de repasse",
          _style: "min-width:150px;",
          filter: false,
        },
      ],
      dadosReumo: [],
      not_found: {
        noResults: "Nenhum registro encontrado",
        noItems: "Nenhum registro encontrado",
      },

      hover: true,
      striped: true,
      bordered: false,
      small: true,
      fixed: true,
      dark: false,
      dadoServicos: [],
      extraInformation: {
        valor_total_pendente: "",
        total_evolucao_pendente: "",
      },
      fieldsBaixa: [
        { key: "patient", label: "Nome", _style: "min-width:200px" },
        { key: "social_name", label: "Nome social", _style: "min-width:200px" },
        { key: "name", label: "Convenio", _style: "min-width:100px;" },
        {
          key: "nameprofessional",
          label: "Profissional",
          _style: "min-width:100px;",
        },
        { key: "email", label: "E-mail", _style: "min-width:100px;" },
        { key: "phone", label: "Telefone", _style: "min-width:40px;" },
        { key: "city", label: "Cidade", _style: "min-width:40px;" },
        {
          key: "sick_leave",
          label: "Data da Baixa",
          _style: "min-width:40px;",
        },
      ],
      pacientes: [],
      pacientesFiltros: [],

      pacienteFiltro: [{
        label: 'PACIENTES',
        value: null
      }]
    };
  },
  methods: {
    buscaDados() {
      this.conveniosChart = [];
      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}profissionais/dados`, {
          params: this.params,
        })
        .then((res) => res.json())
        .then((res) => {
          if (res[0].totcomissao == null) {
            res[0].totcomissao = 0;
          }
          if (res[0].valortotal == null) {
            res[0].valortotal = 0;
          }

          (this.dadosGerais.valorTotal = parseFloat(
            res[0].valortotal
          ).toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          })),
            (this.dadosGerais.numAtendimentos = res[0].numeroconsultas
              ? res[0].numeroconsultas
              : 0),
              (this.dadosGerais.numAtendimentosLiterais = res[0].numeroconsultasliterais
              ? res[0].numeroconsultasliterais
              : 0),
            (this.dadosGerais.valorRepasse = res[0].totcomissao
              ? res[0].totcomissao.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              : 0);
          this.dadosGerais.ticketMedio =
            parseFloat(res[0].valortotal) /
            parseFloat(this.dadosGerais.numAtendimentos)
              ? (
                  parseFloat(res[0].valortotal) /
                  parseFloat(this.dadosGerais.numAtendimentos)
                ).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              : 0;
        })

        .then((res) => {
          this.fechamentoDados();
          // this.listaDadosServico();
        })
        .then((res) => {
          this.resumoDados();
        });
    },
    fechamentoDados() {
      if (this.usuarioLogado.tipo == "2") {
        this.params.profissional = parseInt(this.usuarioLogado.id);
      }
      this.$http
        .post(
          `${process.env.VUE_APP_API_BASE_URL}painel-fechamento/${this.params.profissional}`,
          this.params
        )
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            item.service = item.service.replace("_", " ").toUpperCase();

            item.valorRepasse = item.valorRepasse
              ? parseFloat(item.valorRepasse).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              : 0;

            item.totValor = item.totValor
              ? parseFloat(item.totValor).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              : 0;

            item.taxa =
              item.taxa != null
                ? parseFloat(item.taxa).toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                : 0;
          });
          this.dadosFechamento = res;
        });
    },
    resumoDados() {
      this.baseUrl = `${process.env.VUE_APP_API_BASE_URL}resumo-financeiro`;

      if (this.params.profissional != null) {
        this.baseUrl = `${process.env.VUE_APP_API_BASE_URL}resumo-financeiro/${this.params.profissional}`;
      }
      this.baseUrl = `${process.env.VUE_APP_API_BASE_URL}resumo-financeiro/${this.params.profissional}`;
      this.$http
        .post(this.baseUrl, this.params)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            item.tot_imposto =
              item.tot_imposto != null
                ? parseFloat(item.tot_imposto).toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                : 0;
            item.tot_imposto = item.tot_imposto;
            item.valor_repasse = item.valor_repasse
              ? parseFloat(item.valor_repasse).toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              : 0;

            item.taxa = item.taxa;

            item.name = item.name.toUpperCase();
            if (item.tot_imposto == null) {
              item.tot_imposto = 0;
            }
            this.dadosReumo = res;
          });
        });
    },
    listarProfissionaisSelect() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}profissionais`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            this.profisisonais.push({
              label: item.name.toUpperCase(),
              value: item.id,
            });
          });
        })
        .then((res) => {
          this.params.profissional = this.profisisonais[0].value;
        });
    },

    listarConvenios() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}convenios`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            this.convenios.push({
              label: item.name.toUpperCase(),
              value: item.id,
            });
          });
        });
    },
    listarProfissionais(type_user) {
      if (type_user == "Administrador" || type_user == "Administrador-master") {
        this.showProfGraf = false;
        this.url_destino = "ppm-profissional";
      } else {
        this.showAdmGraf = false;
        this.idUser = localStorage.getItem("id");
        this.url_destino = "ppm-profissional/" + this.idUser;
      }
      // this.$http
      //   .get(`${process.env.VUE_APP_API_BASE_URL}${this.url_destino}`)
      //   .then((res) => res.json())
      //   .then((res) => {

      //     // res.forEach((item) => {
      //     //   this.$http
      //     //     .get(
      //     //       `${process.env.VUE_APP_API_BASE_URL}ppm-particular/${item.id}`
      //     //     )
      //     //     .then((res) => res.json())
      //     //     .then((res) => {
      //     //       let total_particular = "";
      //     //       let valor_particular = "";

      //     //       res.forEach((item) => {
      //     //         total_particular = item.total_particular;
      //     //         valor_particular = item.valor_particular;
      //     //       });

      //     //       item.total_particular = total_particular;

      //     //       if (valor_particular) {
      //     //         if (
      //     //           item.total_particular >= 40 &&
      //     //           item.total_particular <= 59
      //     //         ) {
      //     //           item.valor_particular = `R$: ${valor_particular * 1.1}`;
      //     //         } else {
      //     //           item.valor_particular = `R$: ${valor_particular}`;
      //     //         }
      //     //       } else {
      //     //         item.valor_particular = `R$ ${0}`;
      //     //         this.totalParticular += item.valor_particular;
      //     //       }
      //     //     })
      //     //     .then((res) => {
      //     //       this.totalParticular = this.totalParticular;
      //     //     })
      //     //     .then((res) => {
      //     //       this.$http
      //     //         .get(
      //     //           `${process.env.VUE_APP_API_BASE_URL}ppm-convenios/${item.id}`
      //     //         )
      //     //         .then((res) => res.json())
      //     //         .then((res) => {
      //     //           let receita_convenio = "";
      //     //           let consultas_convenio = "";

      //     //           res.forEach((item) => {
      //     //             receita_convenio = item?.receita_convenio;
      //     //             consultas_convenio = item?.consultas_convenio;
      //     //           });

      //     //           item.receita_convenio = receita_convenio;
      //     //           item.consultas_convenio = consultas_convenio;

      //     //           if (receita_convenio) {
      //     //             if (
      //     //               consultas_convenio >= 30 &&
      //     //               consultas_convenio <= 39
      //     //             ) {
      //     //               item.receita_convenio = `R$ ${receita_convenio + 5.0} `;
      //     //             } else {
      //     //               item.receita_convenio = `R$: ${receita_convenio}`;
      //     //             }
      //     //           } else {
      //     //             item.receita_convenio = `R$: ${0}`;
      //     //           }
      //     //           this.totalConvenio += item.receita_convenio;
      //     //           this.items.push(item);
      //     //         });
      //     //     });
      //     // });
      //   });
    },
    listYear() {
      this.$http
        .get(`${process.env.VUE_APP_API_BASE_URL}lista-anos`)
        .then((res) => res.json())
        .then((res) => {
          res.forEach((elem) => {
            this.anos.push(elem.ano);
          });
          
          // Adicionar 2025 manualmente se não existir na lista
          if (!this.anos.includes({ label: "2025", value: "2025" }) && !this.anos.includes("2025")) {
            this.anos.push({ label: "2025", value: "2025" });
          }
        })
        .catch((error) => {
          
        });
    },
    listarPacientes() {
      this.$http
        .get(process.env.VUE_APP_API_BASE_URL + "pacientes")
        .then((res) => res.json())
        .then((res) => {
         
          this.pacientes = res;
          //filter for name

          this.pacientes.sort((a, b) => {
            if (a.patient < b.patient) {
              return -1;
            }
            if (a.patient > b.patient) {
              return 1;
            }
            return 0;
          });

          this.pacientes.forEach((x) => {
            this.pacienteFiltro.push({
              label: x.patient.toUpperCase(),
              value: x.id
            })

            if (x.nameprofessional == null) {
              x.nameprofessional = "-";
            }
            x.checkProtocol = false;
            x.check = false;
          });

          
          this.pacientes.forEach((elem) => {
            elem.patient = elem.patient
              .split(" ")
              .map(
                (nome) =>
                  nome.charAt(0).toUpperCase() + nome.slice(1).toLowerCase()
              )
              .join(" ");

            elem.city = elem.city
              .split(" ")
              .map(
                (nome) =>
                  nome.charAt(0).toUpperCase() + nome.slice(1).toLowerCase()
              )
              .join(" ");
             if(elem.sick_leave != null){
              elem.sick_leave = moment.utc(elem.sick_leave).format("DD/MM/YYYY")
             }
          });
          this.pacientesFiltros = this.pacientes.filter((x) => {
            return x.sick_leave !== null;
          });
          // this.pacientes = this.pacientes.map(item => ite)
        });
    },
    perfilPaciente(item){
      this.$router.push({
        path: `/pacientes`,
        name: "Pacientes",
        query: { id: item.id, type: "b" },
      });
    }, 
    listarLogs(){
      this.$http.get(process.env.VUE_APP_API_BASE_URL + "logs")
        .then((res) => res.json())
        .then((res)=>{
        
        this.logs = res
      })
    }
  },

  mounted() {
    this.listarLogs()
    this.listarPacientes();
    this.listYear();
    this.usuarioLogado.id = localStorage.getItem("id");
    this.usuarioLogado.tipo = localStorage.getItem("type");

    if (this.usuarioLogado.tipo == 3) {
      this.$router.push("calendario/listar");
    }

    this.listarProfissionaisSelect();
    this.listarConvenios();

    this.buscaDados();
    setTimeout(() => {
      this.resumoDados();
    }, 2000);
    setTimeout(() => {
      this.fechamentoDados();
    }, 2000);

    const date = new Date();
    const today = date.getDate();
    this.mesAtual.id = date.getMonth() + 1;
    if (this.mesAtual.id == 1) {
      this.mesAtual.nome = "Janeiro";
    }
    if (this.mesAtual.id == 2) {
      this.mesAtual.nome = "Fevereiro";
    }
    if (this.mesAtual.id == 3) {
      this.mesAtual.nome = "Março";
    }
    if (this.mesAtual.id == 4) {
      this.mesAtual.nome = "Abril";
    }
    if (this.mesAtual.id == 5) {
      this.mesAtual.nome = "Maio";
    }
    if (this.mesAtual.id == 6) {
      this.mesAtual.nome = "Junho";
    }
    if (this.mesAtual.id == 7) {
      this.mesAtual.nome = "Julho";
    }
    if (this.mesAtual.id == 8) {
      this.mesAtual.nome = "Agosto";
    }
    if (this.mesAtual.id == 9) {
      this.mesAtual.nome = "Setembro";
    }
    if (this.mesAtual.id == 10) {
      this.mesAtual.nome = "Outubro";
    }
    if (this.mesAtual.id == 11) {
      this.mesAtual.nome = "Novembro";
    }
    if (this.mesAtual.id == 12) {
      this.mesAtual.nome = "Dezembro";
    }

    let type_user = localStorage.getItem("type_name");
    this.listarProfissionais(type_user);
  },
  computed: {
    defaultPie() {
      return [
        {
          backgroundColor: ["#41B883", "#E46651", "#00D8FF", "#DD1B16"],
          data: [40, 20, 80, 10],
        },
      ];
    },
    defaultDatasets() {
      return [
        {
          label: "Consultas",
          backgroundColor: "#203864",
          data: [40, 20, 12, 39, 40, 40, 39, 100, 40, 20, 12, 11],
        },
        {
          label: "Consultas",
          backgroundColor: "#ccc",
          data: [40, 20, 12, 39, 40, 40, 39, 100, 40, 20, 12, 11],
        },
      ];
    },
    buscaDadosProfissional() {
      var arrayData = [];
      this.conveniosChart = [];
      this.$http
        .post(
          `${process.env.VUE_APP_API_BASE_URL}profissionais/dados-financeiros/convenios`,
          {
            params: this.params,
          }
        )
        .then((res) => res.json())
        .then((res) => {
          res.forEach((item) => {
            this.conveniosChart.push(item.nome);
            arrayData.push(parseFloat(item.valor).toFixed(2));
          });
        });
      return [
        {
          label: "Consultas",
          backgroundColor: "#203864",
          data: arrayData,
        },
      ];
    },
    listaDadosServico() {
      let arrayDados = [];
      this.dadoServicos = [];
      this.$http
        .post(`${process.env.VUE_APP_API_BASE_URL}listar-servicos`, this.params)
        .then((res) => res.json())
        .then((res) => {
          
          res.forEach((res) => {
            this.dadoServicos.push(res.name);
            arrayDados.push(parseFloat(res.num));
          });
        });

      return [
        {
          backgroundColor: ["#41B883", "#E46651", "#00D8FF", "#DD1B16"],
          data: arrayDados,
        },
      ];
    },
  },
};
</script>
<style scoped>
.div_cards {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1em;
  margin-bottom: 2em;
}
.div_cards div {
  display: inline-block;
  border: 1px solid #ccc;
  padding: 0.1em 1.5em;
  /* flex-grow: 1; */
  width: 20%;
  position: relative;
}
.div-cards-value-evolution {
  width: 50% !important;
}

#rec {
  background-color: #203864 !important;
  width: 2px !important;
  position: absolute;
  left: 0px;
  bottom: 0px;
  padding: 6px;
  height: 80%;
}
.title {
  font-size: 25px;
  color: #666;
}
.valueP {
  font-size: 36px;
  text-align: center;
  font-weight: 700;
  margin: 0px;
  margin-bottom: 10px;
}

@media (max-width: 1700px) {
  .valueP {
    font-size: 26px;
  }
}

@media (max-width: 1400px) {
  .valueP {
    font-size: 18px;
  }
  .title {
    font-size: 14px;
    color: #666;
  }
}
</style>
